module.exports = __webpack_public_path__ + "static/media/take_photo.614c1b5b.svg";